import styled from '@emotion/styled';
import { useHistory } from 'react-router-dom';
import { RubikBold, RubikMedium } from 'shared/components/Text';
import { ROUTES } from 'shared/constants';
import * as Colors from 'shared/styles/colors';
import * as LayoutUtils from '../Home/utils/LayoutUtils';
import { media } from "@mverissimoo/emotion-grid";
import { Breakpoint } from 'shared/types';
import { ReactComponent as FandomLogoStacked } from 'shared/images/Fandom_avatar_maker_lockup_stacked_2-1.svg';

const LandingPage = () => {
  const history = useHistory();

  const goToHomePage = () => {
    history.push(ROUTES.HOME);
  };

  return (
    <LandingPageContainer>
      <OuterContainer>
        <LeftContentContainer>
          <LogoWrapper>
            <FandomLogoStacked />
          </LogoWrapper>
          <MainText>
            Channel your inner fan and share your Fandom love and pride -
            company and network wide! We’re all unique and follow different
            fandoms that are a part of who we are. Show us your fan spirit
            by creating your own personal Fandom style avatar. Your creativity
            journey awaits!
          </MainText>
          <GetStartedButton onClick={() => goToHomePage()}>
            <GetStartedButtonText>
              GET STARTED
            </GetStartedButtonText>
          </GetStartedButton>
        </LeftContentContainer>
        <AvatarViewContainer>
          <AvatarView src="landing-page-example-avatars_1-1.gif" />
        </AvatarViewContainer>
      </OuterContainer>
    </LandingPageContainer>
  );
}

export default LandingPage;

const LandingPageContainer = styled.div({
  display: 'flex',
  width: '100vw',
  height: 'auto',
  position: 'relative',
  backgroundImage: 'url("/site_background_3840x2160_1-1.png")',
  justifyContent: 'center',
  alignContent: 'center',
  alignItems: 'center',
  paddingTop: 24,
  paddingBottom: 36,
  margin: 0,
  [media(Breakpoint.lg)]: {
    height: '100vh',
    padding: 0,
  },
});

const OuterContainer = styled.div({
  width: 340,
  height: 780,
  display: 'flex',
  flexDirection: 'column-reverse',
  flexWrap: 'wrap',
  borderWidth: LayoutUtils.STANDARD_BORDER_WIDTH,
  borderStyle: 'solid',
  borderColor: Colors.purple,
  borderRadius: 4,
  boxShadow: '12px 12px 0px 0px rgba(80, 16, 67, 1)',
  justifyContent: 'center',
  alignSelf: 'center',
  backgroundColor: Colors.white,
  marginBottom: 36,
  [media(Breakpoint.lg)]: {
    width: 936,
    height: 580,
    flexDirection: 'row',
    flexWrap: 'nowrap',
    boxShadow: '16px 16px 0px 0px rgba(80, 16, 67, 1)',
    justifyContent: 'space-between',
    margin: 0,
  },
});

const LeftContentContainer = styled.div({
  width: '90%',
  display: 'flex',
  flexDirection: 'column',
  position: 'relative',
  justifyContent: 'space-between',
  paddingLeft: 16,
  paddingRight: 0,
  paddingTop: 24,
  paddingBottom: 0,
  marginRight: 0,
  [media(Breakpoint.lg)]: {
    width: '100%',
    paddingLeft: 48,
    paddingRight: 0,
    paddingTop: 48,
    paddingBottom: 48,
    marginRight: 24,
  },
});

const LogoWrapper = styled.div({
  width: 240,
  alignSelf: 'center',
  marginTop: 0,
  marginBottom: 24,
  [media(Breakpoint.lg)]: {
    width: 280,
    alignSelf: 'flex-start',
    marginTop: 24,
    marginBottom: 0,
  },
});

const MainText = styled.div([
  RubikMedium,
  {
    width: '100%',
    fontSize: 14,
    lineHeight: 1.8,
    color: Colors.purple,
    textAlign: 'center',
    marginBottom: 24,
    [media(Breakpoint.lg)]: {
      textAlign: 'start',
      marginBottom: 0,
    },
  },
]);

const GetStartedButton = styled.button({
  display: 'flex',
  flexDirection: 'row',
  cursor: 'pointer',
  width: 170,
  height: 48,
  borderWidth: LayoutUtils.STANDARD_BORDER_WIDTH,
  borderColor: Colors.purple,
  borderStyle: 'solid',
  justifyContent: 'center',
  alignContent: 'center',
  alignItems: 'center',
  alignSelf: 'center',
  backgroundColor: Colors.red,
  marginBottom: 0,
  [media(Breakpoint.lg)]: {
    alignSelf: 'flex-start',
    marginBottom: 24,
  },
});

const GetStartedButtonText = styled.span([
  RubikBold,
  {
    color: Colors.cream,
    alignItems: 'center',
    fontSize: 16,
  }]
);

const AvatarViewContainer = styled.div({
  display: 'flex',
  width: '100%',
  height: 'auto',
  justifyContent: 'center',
  alignItems: 'center',
  backgroundColor: Colors.white,
  padding: 0,
  marginTop: 24,
  marginBottom: 24,
  [media(Breakpoint.lg)]: {
    width: '100%',
    height: 'auto',
    padding: 36,
    marginTop: 0,
    marginBottom: 0,
  },
});

const AvatarView = styled.img({
  boxSizing: 'border-box',
  width: 280,
  height: 'auto',
  resize: 'both',
  [media(Breakpoint.lg)]: {
    width: 500,
    height: 'auto',
    resize: 'none',
  },
})
